import $ from 'jquery';

const focusInput = (target) => {
	$(target).on("keyup", function () {
		if ($(target).val() !== "") {
			$(target).addClass("focus");
		} else {
			$(target).removeClass("focus");
		}
	});
};

function useFocusInput() {
  return { focusInput };
}

export default useFocusInput;

